/*

Note:
1. please replace class/IDs of error message, promotion code box and discount remove button.
document.querySelector("#invalid-discount")
document.querySelector('#promotion_code')
document.querySelector(".discount-code-input")

*/

function collectPromotionGiftIds() {
  const variantIds = new Set();
  const productIds = new Set();

  (window.promotionSettings?.gwp || []).forEach((promotion) => {
    (promotion.gifts || []).forEach((gift) => {
      if (gift?.id) variantIds.add(Number(gift.id));
      if (gift?.product_id) productIds.add(Number(gift.product_id));
    });
  });

  return { variantIds, productIds };
}

function isGwpGiftLineItem(item, promotionGiftIds) {
  const variantId = Number(item.id || item.variant_id);
  const productId = Number(item.product_id);

  return (
    (item.product_type && item.product_type.toLowerCase() === 'gift') ||
    promotionGiftIds.variantIds.has(variantId) ||
    promotionGiftIds.productIds.has(productId)
  );
}

function giftVariantAlreadyInCart(giftId, cartResponse) {
  const normalizedGiftId = Number(giftId);
  if (!normalizedGiftId) return false;

  if (
    window.cartItemsData?.giftsInCart?.some((id) => Number(id) === normalizedGiftId)
  ) {
    return true;
  }

  let giftProductId = null;
  (window.promotionSettings?.gwp || []).some((promotion) =>
    (promotion.gifts || []).some((gift) => {
      if (Number(gift.id) === normalizedGiftId) {
        giftProductId = gift.product_id ? Number(gift.product_id) : null;
        return true;
      }
      return false;
    })
  );

  const promotionGiftIds = collectPromotionGiftIds();

  return (cartResponse?.items || []).some((item) => {
    if (Number(item.id) === normalizedGiftId) return true;
    if (
      giftProductId &&
      Number(item.product_id) === giftProductId &&
      isGwpGiftLineItem(item, promotionGiftIds)
    ) {
      return true;
    }
    return false;
  });
}

function isPromotionVisibleToCustomer(promotion) {
  if (!promotion?.match_tag) return false;
  if (promotion.isLoggedIn && !window.theme?.isLoggedIn) return false;
  if (promotion.isNewCustomer) {
    if (!window.theme?.isLoggedIn) return false;
    if (Number(window.theme?.customerSpent) !== 0) return false;
  }
  return true;
}

function ensureGwpCartItemsData() {
  window.cartItemsData = window.cartItemsData || {};
  window.cartItemsData.productData = window.cartItemsData.productData || [];
  window.cartItemsData.productSku = window.cartItemsData.productSku || [];
  window.cartItemsData.productID = window.cartItemsData.productID || [];
  window.cartItemsData.productType = window.cartItemsData.productType || [];
  window.cartItemsData.productVendor = window.cartItemsData.productVendor || [];
  window.cartItemsData.giftsInCart = window.cartItemsData.giftsInCart || [];
  window.cartItemsData.gifts = window.cartItemsData.gifts || [];
  window.cartItemsData.giftsInCartWithQuantity = window.cartItemsData.giftsInCartWithQuantity || [];
  window.cartItemsData.cartTotal = window.cartItemsData.cartTotal || 0;
  return window.cartItemsData;
}

ensureGwpCartItemsData();

let promotionValidateQueue = Promise.resolve();

/* Add gift product to cart */

_addGiftProduct = async function(gift_data, cartResponse) {
  if(gift_data.length <= 0) { return false; }

  gift_data = gift_data.filter((gift) => !giftVariantAlreadyInCart(gift.id, cartResponse));
  gift_data = Array.from(new Map(gift_data.map((gift) => [Number(gift.id), gift])).values());
  if(gift_data.length <= 0) { return false; }

  const sectionsToBundle = [];
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
  );

  const items = gift_data.map((gift) => {
    const item = { id: gift.id, quantity: gift.quantity || 1 };
    if (gift.properties) {
      item.properties = gift.properties;
    }
    return item;
  });

  return fetch(KROWN.settings.routes.cart_add_url+'.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      items: items,
      sections: sectionsToBundle,
      sections_url: window.location.pathname
    })
  })
  .then((response) => response.json())
  .then((data) => {
    if (data.status) {
      return false;
    }
    return data;
  })
  .catch(() => false);
};

window.addProduct = async function (items) {
  return await _addGiftProduct(items);
}
//update giftInCart
function removeSimilarKeys(arr, obj) {
    let newObj = [];
    Object.keys(obj).forEach((key,i ) => {
      newObj.push(parseInt(key));
    });
    let newArr = arr.filter(value => !newObj.includes(value));
    return newArr;
}

/* Remove gift product from cart */

_removeGiftProduct = async function(gift_data) {
  window.cartItemsData.giftsInCart.forEach((gift) => {
    if(!window.giftInPromotion.includes(gift)) {
      gift_data[gift] = 0;

    }
  });

  if(Object.keys(gift_data).length > 0) {
    // let newGiftData;
    // newGiftData = removeSimilarKeys(window.cartItemsData.giftsInCart, gift_data);
    // window.cartItemsData.giftsInCart = Object.keys(newGiftData);
    window.cartItemsData.giftsInCart = removeSimilarKeys(window.cartItemsData.giftsInCart, gift_data);
  }
  if(Object.keys(gift_data).length <= 0) { return false; }

  gift_data = Object.assign({}, gift_data);
  var productData = {updates: gift_data};
  return await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(productData)
  })
  .then(response => {
    if (response.status === 200) {
      return response.json()
    }
  })
  .catch(error => {
    console.log((`Failed to get request, API returned ${error.status} ${error.statusText}`));
  })
  
  //throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
  
};

window.removeProduct = async function (items) {
return await _removeGiftProduct(items)
}

/* Clear cart */

_clearCart = async function() {
  var result = await fetch('/cart/clear.js', {
      method: 'GET',
      headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
      }
  })

  if (result.status === 200) {
      window.cart_clear = true;
      return result.json();
  }

  throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}

/* Show/hide error message */

invalidPromotionCode = function(display) {
  var invalid_promocode = document.querySelector("#invalid-discount");

  if (!invalid_promocode) return;

  if (display === "block" || display === "flex") {
    invalid_promocode.hidden = false;
  } else {
    invalid_promocode.hidden = true;
  }
}

window.restoreGwpPromoCodeFromStorage = function () {
  var promoCode = localStorage.getItem("promocode");
  var promocode_input = document.querySelector('#promotion_code');
  var discountCodeInput = document.querySelector(".discount-code-input");
  var closeButton = document.querySelector(".discount-code-input-close");

  if (!promocode_input || !window.discount) return;

  if (promoCode != null && window.discount.includes(promoCode)) {
    promocode_input.value = promoCode;
    promocode_input.setAttribute('readonly', 'readonly');
    if (discountCodeInput) discountCodeInput.classList.add('code-applied');
    if (closeButton) closeButton.hidden = false;
  }
}

/* Add discount code */
window.addCodeStack = async function(event) {
  if (event) event.preventDefault();
  var promocode = document.querySelector('#promotion_code');
  if (!promocode || !window.discount) return;

  var code = promocode.value.trim().toUpperCase();
  promocode.value = code;

  if (!code) {
    invalidPromotionCode("block");
    return;
  }

  if(window.discount.includes(code)){
    invalidPromotionCode("none");
    await window.promotionValidate();
    await window.refreshCart();
    window.restoreGwpPromoCodeFromStorage();
  } else {
    invalidPromotionCode("block");
  }
}
/* Remove discount code */

window.removeCodeStack = async function() {
  var promocode = document.querySelector('#promotion_code');
  var discountCodeInput = document.querySelector(".discount-code-input");
  var closeButton = document.querySelector(".discount-code-input-close");

  if (promocode) {
    promocode.value = "";
    promocode.removeAttribute('readonly');
  }
  if (discountCodeInput) discountCodeInput.classList.remove('code-applied');
  if (closeButton) closeButton.hidden = true;
  localStorage.removeItem("promocode");
  invalidPromotionCode("none");
  await window.promotionValidate();
  await window.refreshCart();
}

/* Clear discount box */

window.clearCodeStack = async function() {
  var promocode = document.querySelector('#promotion_code'), discountCodeInput = document.querySelector(".discount-code-input");
  var closeButton = document.querySelector(".discount-code-input-close");
  localStorage.removeItem("promocode");
  if (promocode) {promocode.value = ""; promocode.removeAttribute('readonly');}
  if (discountCodeInput) discountCodeInput.classList.remove('code-applied');
  if (closeButton) closeButton.hidden = true;
  invalidPromotionCode("none");
}

/* Compare lists */

compareArrays = function (promotion = [], promotionArray = [], productCount, type = "", index) {
  if(promotion.operationType == "and") {
      var matched_product1 = [], matched_product2 = [];
      promotionArray.filter(x => {
          if(promotion.productList1.includes(x)) {
              matched_product1.push(x);
          }
          if(promotion.productList2.includes(x) && !matched_product2.includes(x)) {
              matched_product2.push(x);
          }
      })
      // if both list has same product info
      // for example: if same sku is added in both list then quantity should be 2 or greater

      if (matched_product1.length == 1 && matched_product2.length == 1 && matched_product1[0] == matched_product2[0]) {
          var and_flag = false;
          window.cartItemsData.productData.filter(x => {
              if(type == "sku" && matched_product1.includes(x.sku) && x.quantity >= 2) {
                  and_flag = true;
              } else if (type == "type" && matched_product1.includes(x.type) && x.quantity >= promotion.productCount) {
                  and_flag = true;
              } else if (type == "product_id" && matched_product1.includes(x.productID) && x.quantity >= 2) {
                  and_flag = true;
              } else if (type == "vendor" && matched_product1.includes(x.vendor) && x.quantity >= 2) {
                  and_flag = true;
              } else {
                  and_flag = false;
              }
          })
          if(and_flag) {
              return true;
          }
      } else if (matched_product1.length >= promotion.productCount && matched_product2.length >= 1) {
          //if condition purchase count on the list is 1
          return true;
      } else if( matched_product1.length >= 1 && promotion.productCount >= 2 && matched_product2.length >= 1) {
          //if condition purchase count on the list is 2 or more than 2
          window.cartItemsData.productData.filter(x => {
              if(type == "sku" && matched_product1.includes(x.sku) && x.quantity >= promotion.productCount) {
                  and_flag = true;
              } else if (type == "type" && matched_product1.includes(x.type) && x.quantity >= promotion.productCount) {
                  and_flag = true;
              } else if (type == "product_id" && matched_product1.includes(x.productID) && x.quantity >= 2) {
                  and_flag = true;
              } else if (type == "vendor" && matched_product1.includes(x.vendor) && x.quantity >= 2) {
                  and_flag = true;
              }
              //  else {

              //     and_flag = false;
              // }
          });
          if(and_flag) {
              return true;
          }
      } else {
          return false;
      }
  } else if (type == "excludeProduct") {
      var excluded = false;
      if(promotion.minimumCartAmount || promotion.maximumCartAmount) { // price of excluded product will not count if minimum amount specified
          var cartTotal = 0, matchFound = false;
          var productData = window.cartItemsData.productData
          var cartItemTotal = window.cartItemsData.cartTotal;
          for(let i = 0; i < productData.length; i++) {
              let data = productData[i];
              var dataType = data.type;
              var dataSku = data.sku;
              let itemHasDiscount = false;
              if(promotion.excludeDiscountedProduct && data.discountTitles){
                const discountTitles = data.discountTitles.split(",");
                itemHasDiscount = (promotion.excludeDiscountedProduct.length > 0) ? discountTitles.some(discountTitle => promotion.excludeDiscountedProduct.some(exld => discountTitle?.toLowerCase().includes(exld)) ) : false;
              }
              if(promotion.excludeProduct && dataType !== '' && promotion.excludeProduct.includes(dataType) && !data.hasDiscount) {
                  cartItemTotal = cartItemTotal - data.price
                  cartTotal = cartItemTotal;
                  matchFound = true;
              } else if (promotion.excludeProductSku && dataSku !== '' && promotion.excludeProductSku.includes(dataSku) && !data.hasDiscount){
                  cartItemTotal = cartItemTotal - data.price
                  cartTotal = cartItemTotal;
                  matchFound = true;
              } else if (itemHasDiscount){
                  cartItemTotal = cartItemTotal - data.price
                  cartTotal = cartItemTotal;
                  matchFound = true;
              }else {
                window.promotionSettings.gwp[index].includedTotalPrice+= data.price
              }
          }
          if(cartTotal <= 0 && !matchFound) {
              cartTotal = window.cartItemsData.cartTotal;
          }
          if(promotion.minimumCartAmount && !promotion.maximumCartAmount) {
              if(cartTotal >= promotion.minimumCartAmount) {
                  excluded = true;
              }
          } else if (!promotion.minimumCartAmount && promotion.maximumCartAmount) {
              if(cartTotal <= promotion.maximumCartAmount) {
                  excluded = true;
                  if(!promotion.conditionArray.includes("maximumCartAmount")) {
                      promotion.conditionArray.push("maximumCartAmount");
                  }
              }
          } else if(promotion.minimumCartAmount && promotion.maximumCartAmount) {
              if(cartTotal >= promotion.minimumCartAmount && cartTotal <= promotion.maximumCartAmount) {
                  excluded = true;
                  if(!promotion.conditionArray.includes("maximumCartAmount")) {
                      promotion.conditionArray.push("maximumCartAmount");
                  }
              }
          }
      } else {
          window.cartItemsData.productData.filter(x => { // Exclude product type
              let exclude1 = false,exclude2 = false,exclude3 = false;
            
              let itemHasDiscount = false;
              if(promotion.excludeDiscountedProduct && x.discountTitles){
                const discountTitles = x.discountTitles.split(",");
                itemHasDiscount = (promotion.excludeDiscountedProduct.length > 0) ? discountTitles.some(discountTitle => promotion.excludeDiscountedProduct.some(exld => discountTitle?.toLowerCase().includes(exld)) ) : false;
              }
            
              if((promotion.excludeProduct && !promotion.excludeProduct.includes(x.type)) || !promotion.excludeProduct ){
                 exclude1 = true
              }
              if((promotion.excludeProductSku && !promotion.excludeProductSku.includes(x.sku)) || !promotion.excludeProductSku ){
                 exclude2 = true
              }
              if((promotion.excludeDiscountedProduct && !itemHasDiscount) || !promotion.excludeDiscountedProduct ){
                 exclude3 = true
              }
              if(exclude1 && exclude2 && exclude3) {
                  excluded = true;
                  window.promotionSettings.gwp[index].includedTotalPrice+= x.price
              }
          });
      }
      return excluded ? true : false;
  } else {
      var matched_product = [], quantity_count = 0;

      promotionArray.filter(x => {
          if(promotion.productList1.includes(x)) {
              matched_product.push(x);
          }
      });
      window.cartItemsData.productData.filter(x => {
          if(type == "sku" && matched_product.includes(x.sku)) {
            window.promotionSettings.gwp[index].includedTotalPrice+= x.price
            quantity_count = quantity_count + x.quantity;
          } else if (type == "type" && matched_product.includes(x.type)) {
            quantity_count = quantity_count + x.quantity;
            window.promotionSettings.gwp[index].includedTotalPrice+= x.price
          } else if (type == "product_id" && matched_product.includes(x.productID)) {
            quantity_count = quantity_count + x.quantity;
            window.promotionSettings.gwp[index].includedTotalPrice+= x.price
          } else if (type == "vendor" && matched_product.includes(x.vendor)) {
            quantity_count = quantity_count + x.quantity;
            window.promotionSettings.gwp[index].includedTotalPrice+= x.price
          }
      });

      if(quantity_count >= productCount) {
          return true;
      } else {
          return false;
      }
  }
}

/* Get product from cart */

_getCart = async function () {
  const result = await fetch(KROWN.settings.routes.cart_url + '.js', {
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
      }
  })

  if (result.status === 200) {
    return result.json();
  }

  throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}

window.progressBar = function (elem = document) {
  if (!window.promotionSettings || !window.promotionSettings.gwp) return true;

  const cartItemsData = ensureGwpCartItemsData();
  const progressRoot = elem.querySelector('.price-progress-bar');
  if (!progressRoot) return true;

  var gwpList = window.promotionSettings.gwp,
    priceLists = [],
    remainingAmountHTML = "",
    include_total_price = 0,
    total_price = 0,
    totalTiers = [],
    tierCount = 1,
    total_value_set_price = 0;
  let cartTotalValue = cartItemsData.cartTotal || 0;
  let promotionCodeRules = [];
  // get the discount amount to exclude from the gwp calculation
  let excludeAmountFromGWPComputation = cartItemsData.productData.filter((item) => item?.hasDiscount).reduce((acc, item) => acc + item.price, 0) || 0;

  if (cartTotalValue > 0) {
    gwpList.forEach((promotion) => {
      if (!promotion.excludeProduct && !promotion.excludeProductSku && !promotion.excludeDiscountedProduct) {
        promotion.includedTotalPrice = cartTotalValue;
      }
    });
  }

  for(let i = 0; i < gwpList.length; i++) {
    // updated includedTotalPrice, when discount text is match from the theme settings
    if( excludeAmountFromGWPComputation > 0 ){
      // window.cartItemsData.cartTotal
      gwpList[i].includedTotalPrice_progress = gwpList[i].includedTotalPrice - excludeAmountFromGWPComputation
    }else{
      gwpList[i].includedTotalPrice_progress = gwpList[i].includedTotalPrice
    }

    let promotion = gwpList[i];
    if (!isPromotionVisibleToCustomer(promotion)) {
      continue;
    }
    if(promotion.excludeProduct !== false || promotion.excludeProductSku !== false || promotion.excludeDiscountedProduct !== false) {
     include_total_price = promotion.includedTotalPrice_progress;
    }
    let show_process = promotion.match_tag;
    let excluded_skus_str = [],excluded_product_skus_str = [];
    if(promotion.excludeByGwpSku){
      promotion.excludeByGwpSku.split(",").forEach(item => {
        excluded_skus_str.push(item)
      })
      
      gwpList.forEach(p => {
        let is_exclude = false
        p.gifts.map(item => item.sku).forEach(sku => {
          if(excluded_skus_str.includes(sku)){
            is_exclude = true
          }
        })
        if(!p.code && !p.minimumCartAmount && p.conditionType == "any_purchase" && p.match_tag && is_exclude) {
          show_process = false
        }else if(!p.code && p.minimumCartAmount && p.match_tag  && is_exclude ) {
          show_process = false
        }
      });
    }
    if(promotion.excludeByProductSku){
      promotion.excludeByProductSku.split(",").forEach(item => {
        excluded_product_skus_str.push(item)
      })
      cartItemsData.productData.forEach(product => {
        let is_exclude = false
        if(excluded_product_skus_str.includes(product.sku)){
          is_exclude = true
        }
        if(!promotion.code && !promotion.minimumCartAmount && promotion.conditionType == "any_purchase" && promotion.match_tag && is_exclude) {
          show_process = false
        }else if(!promotion.code && promotion.minimumCartAmount && promotion.match_tag  && is_exclude ) {
          show_process = false
        }
      })
    }
    if(!promotion.code && !promotion.minimumCartAmount && promotion.conditionType == "any_purchase" && show_process ) {
      //automatic gift
      if(promotion.gifts && promotion.gifts.length > 0) {
        priceLists.push({price: 0, title: arrayToEnWords(promotion.gifts), maxPrice: promotion.maximumCartAmount ? promotion.maximumCartAmount : 0, minPrice: promotion.minimumCartAmount ? promotion.minimumCartAmount : 0, promotion: promotion})
        totalTiers.push({tier: tierCount, minimumCartAmount: (!promotion.minimumCartAmount) ? 0 : promotion.minimumCartAmount,title: arrayToEnWords(promotion.gifts), promotion: promotion });
        tierCount++;
      }
    }else if(!promotion.code && promotion.minimumCartAmount && show_process) {
      if(promotion.gifts[0] && promotion.gifts[0].title) {
        priceLists.push({price: promotion.minimumCartAmount, title: arrayToEnWords(promotion.gifts), maxPrice: promotion.maximumCartAmount ? promotion.maximumCartAmount : 0, minPrice: promotion.minimumCartAmount ? promotion.minimumCartAmount : 0, promotion: promotion})
        totalTiers.push({tier: tierCount, minimumCartAmount: (!promotion.minimumCartAmount) ? 0 : promotion.minimumCartAmount, title: arrayToEnWords(promotion.gifts), promotion: promotion });
        tierCount++;
      }
      
    } else if(promotion.code && promotion.gifts[0]) {
        promotionCodeRules.push({price: promotion.minimumCartAmount, title: arrayToEnWords(promotion.gifts), maxPrice: promotion.maximumCartAmount ? promotion.maximumCartAmount : 0, minPrice: promotion.minimumCartAmount ? promotion.minimumCartAmount : 0, promotion: promotion})
    }
  }
  // for(let i = 0; i < window.cartItemsData.productData.length; i++) {
  //   let variant = window.cartItemsData.productData[i];
  //   if(variant.type != "value set") {
  //     total_price = total_price + variant.price;
  //   } else {
  //     total_value_set_price = total_value_set_price + variant.price;
  //   }
  // }
  var tick =`<svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.85686 0.375H6.01504C5.83195 0.375 5.65785 0.455901 5.55015 0.59459L2.72852 4.19388L1.45053 2.56264C1.34283 2.42561 1.17052 2.34305 0.985643 2.34305H0.143822C0.0271513 2.34305 -0.041056 2.46523 0.0271513 2.55274L2.26363 5.40575C2.31647 5.47358 2.38612 5.52885 2.46681 5.56698C2.5475 5.60511 2.63691 5.625 2.72762 5.625C2.81834 5.625 2.90775 5.60511 2.98844 5.56698C3.06913 5.52885 3.13878 5.47358 3.19161 5.40575L6.97173 0.584684C7.04174 0.497178 6.97353 0.375 6.85686 0.375Z" fill="white"/>
    </svg>`;
  var message1Counter = 0, message2Counter = 0, currentPromoPrice = 0, fullfilledTier = 0, unFullfilledTier = 0;
  let codeUsed = localStorage.getItem("promocode");
  for(let index = 0; index < priceLists.length; index++) {
    let priceList = priceLists[index];
    var price = priceList.price, title = priceList.title;
    if(priceList.promotion.operationType != "and" && priceList.promotion.conditionType != "sku") {
        if(promotionCodeRules.length > 0 && codeUsed != null) {
          for(let ind = 0; ind < promotionCodeRules.length; ind++) {
            let pr = promotionCodeRules[ind]
            if((cartTotalValue >= pr.price && pr.promotion.code && pr.promotion.code.split(", ").includes(codeUsed)) || (pr.price == false && pr.promotion.code && pr.promotion.code.split(", ").includes(codeUsed))){
              let mess = '<li class="price-indicatiors">'+KROWN.settings.locales.cart_promotion_thank_you_code+'<b>'+codeUsed+'</b>! <p style="display: inline">'+KROWN.settings.locales.cart_promotion_eligible+'</p> <span class="gift-title">'+pr.title+'</span>!</li>';
              if(remainingAmountHTML.indexOf(mess) == -1) {
                remainingAmountHTML = remainingAmountHTML + mess;
              }
            }
          }
        }
    }
  }
  if(elem.querySelector(".price-progress-bar .remaining-amount")){
    elem.querySelector(".price-progress-bar .remaining-amount").innerHTML = remainingAmountHTML;
  }
  let promotionSettings = window.promotionSettings.gwp;
  promotionSettings.forEach((e) => {
    if(e.includedTotalPrice_progress > 0) {
      include_total_price = e.includedTotalPrice_progress;
    }
  })
  let progressBar = progressRoot.querySelector('.meter');
  let tierLength = totalTiers.length - 1;
  let maxTierPrice = ( totalTiers[tierLength] && totalTiers[tierLength].minimumCartAmount) ? totalTiers[tierLength].minimumCartAmount : 0;
  let currentCartTotal = include_total_price;
  
  let markerPosition = 0, fulfilledTier = 0;
  let liTierHTML = "";
  const remainingAmountEl = progressRoot.querySelector('.remaining-amount');
  const dataMarkersEl = progressRoot.querySelector('.data-markers');
  if (!remainingAmountEl || !dataMarkersEl || !progressBar) return true;

  remainingAmountEl.innerHTML = "";
  dataMarkersEl.innerHTML = "";
  totalTiers.forEach((t) => {
    // for tier marker
    let spanTier = document.createElement("span");
    markerPosition = (t.minimumCartAmount / maxTierPrice) * 100;
    spanTier.innerText = t.tier ;
    markerPosition = (markerPosition >= 96) ? 96: markerPosition;
    spanTier.style.left = markerPosition + '%';
    markerPosition+= markerPosition;
    if(markerPosition >= 100) {
      markerPosition = 100;
    }
    // for tier message
    let liTier = '';
    const tierIncludedTotal = t.promotion.includedTotalPrice_progress ?? t.promotion.includedTotalPrice ?? 0;
    const tierMinimum = t.minimumCartAmount || 0;
    const tierReached = tierMinimum > 0 && tierIncludedTotal >= tierMinimum;

    if (cartItemsData.giftsInCart.length == 0 || cartItemsData.productData.length == 0) {
      if (t.promotion.conditionType == 'any_purchase' && !t.promotion.minimumCartAmount) {
        liTier =
          '<li class="price-indicatiors" data-price-indicatiors-1">' +
          KROWN.settings.locales.cart_promotion_add_any +
          '<span class="gift-title">' +
          t.title +
          '</span>!</li>';
        spanTier.style.left = '0';
        spanTier.setAttribute('data-fulfill', false);
      } else if (tierReached) {
        liTier =
          '<li class="price-indicatiors" data-price-indicatiors-4">' +
          KROWN.settings.locales.cart_promotion_congratulations +
          '<span class="gift-title">' +
          t.title +
          '</span>!</li>';
        spanTier.setAttribute('data-fulfill', true);
        fulfilledTier = tierIncludedTotal;
      } else {
        let computedRemaining = tierMinimum;
        if (cartItemsData.productData.length > 0) {
          computedRemaining = Math.max(0, tierMinimum - tierIncludedTotal);
        }
        liTier =
          '<li class="price-indicatiors" data-price-indicatiors-2">' +
          KROWN.settings.locales.cart_promotion_spend +
          '<span class="price">$' +
          computedRemaining +
          '</span>' +
          KROWN.settings.locales.cart_promotion_more +
          '<span class="gift-title">' +
          t.title +
          '</span>!</li>';
        spanTier.setAttribute('data-fulfill', false);
        fulfilledTier = tierIncludedTotal;
      }
    } else {
      if (t.minimumCartAmount == 0 && currentCartTotal == 0) {
        liTier =
          '<li class="price-indicatiors" data-price-indicatiors-3">' +
          KROWN.settings.locales.cart_promotion_add_any +
          '<span class="gift-title">' +
          t.title +
          '</span>!</li>';
        spanTier.style.left = '0';
        spanTier.setAttribute('data-fulfill', false);
      } else if (tierReached) {
        liTier =
          '<li class="price-indicatiors" data-price-indicatiors-4">' +
          KROWN.settings.locales.cart_promotion_congratulations +
          '<span class="gift-title">' +
          t.title +
          '</span>!</li>';
        spanTier.setAttribute('data-fulfill', true);
        fulfilledTier = tierIncludedTotal;
      } else {
        const computedRemaining = Math.max(0, tierMinimum - tierIncludedTotal);
        liTier =
          '<li class="price-indicatiors" data-price-indicatiors-5">' +
          KROWN.settings.locales.cart_promotion_spend +
          '<span class="price">$' +
          computedRemaining +
          '</span>' +
          KROWN.settings.locales.cart_promotion_more +
          '<span class="gift-title">' +
          t.title +
          '</span>!</li>';
        spanTier.setAttribute('data-fulfill', false);
      }
    }
    
    let progressBarMarker = Math.round((fulfilledTier / maxTierPrice) * 100);
    if (cartItemsData.giftsInCart.length > 0 && cartItemsData.productData.length > 0) {
      const widthPercent = tierReached
        ? 100
        : Math.min(100, progressBarMarker);
      progressBar.querySelector('[data-meter]').style.width = `${widthPercent}%`;
    } else if(cartItemsData.productData.length == 0) {
      progressBar.querySelector("[data-meter]").style.width = "0%";
    } else {
      if (t.promotion.minimumCartAmount > 0) {
        let widthPercent = Math.round((fulfilledTier / t.promotion.minimumCartAmount) * 100);
        if (tierReached || widthPercent >= 100) {
          widthPercent = 100;
        }
        progressBar.querySelector('[data-meter]').style.width = widthPercent + '%';
      } else {
        progressBar.querySelector('[data-meter]').style.width = '0%';
      }
    }
    dataMarkersEl.appendChild(spanTier);
    liTierHTML += liTier;
  });
  remainingAmountEl.innerHTML = liTierHTML + remainingAmountHTML;
  return true;
}

window.buildGwpCartItemsData = function (response) {
  if (!response) return;

  let excludeDiscountedProduct = window.excludeDiscountedProduct
    ? window.excludeDiscountedProduct.toLowerCase().split(', ')
    : '';

  ensureGwpCartItemsData();
  window.cartItemsData.productData = [];
  window.cartItemsData.productSku = [];
  window.cartItemsData.productID = [];
  window.cartItemsData.productType = [];
  window.cartItemsData.productVendor = [];
  window.cartItemsData.giftsInCart = [];
  window.cartItemsData.gifts = [];
  window.cartItemsData.giftsInCartWithQuantity = [];
  window.cartItemsData.cartTotal = 0;

  const promotionGiftIds = collectPromotionGiftIds();
  let giftLineTotal = 0;

  for (let i = 0; i < response.items.length; i++) {
    let item = response.items[i];
    let itemHasDiscount =
      excludeDiscountedProduct.length > 0
        ? item?.discounts.some((cartItem) =>
            excludeDiscountedProduct.some((exld) => cartItem.title?.toLowerCase().includes(exld))
          )
        : false;

    if (!isGwpGiftLineItem(item, promotionGiftIds)) {
      window.cartItemsData.productData.push({
        id: item.id,
        productID: item.product_id.toString(),
        sku: item.sku,
        vendor: item.vendor.toLowerCase(),
        quantity: item.quantity,
        price: item.line_price / 100,
        title: item.title,
        discountTitle: item?.discounts.length ? item?.discounts[0].title : '',
        type: item.product_type.toLowerCase(),
        hasDiscount: itemHasDiscount,
        discountTitles: item?.discounts.length ? item.discounts.map((temp) => temp.title).join(',') : '',
      });
      window.cartItemsData.productSku.push(item.sku);
      window.cartItemsData.productID.push(item.product_id.toString());
      window.cartItemsData.productType.push(item.product_type.toLowerCase());
      window.cartItemsData.productVendor.push(item.vendor.toLowerCase());
    } else {
      giftLineTotal += item.line_price / 100;
      if (!window.cartItemsData.giftsInCart.some((id) => Number(id) === Number(item.id))) {
        window.cartItemsData.giftsInCart.push(item.id);
      }
      window.cartItemsData.gifts.push(item);
      window.cartItemsData.giftsInCartWithQuantity.push({ id: item.id, quantity: item.quantity });
    }
  }

  let excludeAmountFromGWPComputation =
    window.cartItemsData?.productData
      .filter((item) => item?.hasDiscount)
      .reduce((acc, item) => acc + item.price, 0) || 0;
  let totalPrice = response.total_price / 100;
  window.cartItemsData.cartTotal = totalPrice - excludeAmountFromGWPComputation - giftLineTotal;
};

async function runPromotionValidate() {
  if (!window.promotionSettings || !window.promotionSettings.gwp || !window.promotionSettings.gwp.length) {
    return true;
  }
  document.querySelector(".cart-loading-overlay")?.removeAttribute("style");
  var alreadyAppliedGift = [];
  window.cart_clear = false;
  var promocode = document.querySelector('#promotion_code'), discountCodeInput = document.querySelector(".discount-code-input");
  let excludeDiscountedProduct = (window.excludeDiscountedProduct) ? window.excludeDiscountedProduct?.toLowerCase().split(', ') : "";

  await _getCart().then(async function(response) {
      if(response) {
          window.buildGwpCartItemsData(response);
      }

      var excluded_skus = [], excluded_product_skus = [];

      
      var gwpList = window.promotionSettings.gwp,
          giftToAdd = [], // gift will add to cart
          giftToRemove = {}, // gift will remove from cart
          conditionArray = [],
          randomGifts = [],
          clearCart = false,
          appliedCode = promocode && promocode.value ? promocode.value.toUpperCase() : "";
      /* Fatch products from local storage which randomly applied in cart */

      if(localStorage.getItem('randomGifts')) {
          // randomGifts = JSON.parse(localStorage.getItem('randomGifts'));
          try {
            randomGifts = JSON.parse(localStorage.getItem('randomGifts')) || [];
            if (!Array.isArray(randomGifts)) randomGifts = [];
          } catch {
            randomGifts = [];
            localStorage.removeItem('randomGifts');
          }
      }
      window.giftInPromotion = [];
      for (let i = 0; i < gwpList.length; i++) {  
        let promotion = gwpList[i];
        for (let i = 0; i < promotion.gifts.length; i++) {
          let gift = promotion.gifts[i];
          window.giftInPromotion.push(gift.id)
        }
      }

      /* conditions will check if cart has any non-gift products */
      if(window.cartItemsData.productData.length > 0) {
        for (let i = 0; i < gwpList.length; i++) {
            if (!isPromotionVisibleToCustomer(gwpList[i])) {
              continue;
            }
            window.promotionSettings.gwp[i].includedTotalPrice = 0;
            let promotion = gwpList[i];
            
            /* create an array of an options which is enabled in theme settings: start */
            
            if(promotion.minimumCartAmount != false) {
                conditionArray.push("minimumCartAmount");
            }
            if(promotion.maximumCartAmount != false) {
                conditionArray.push("maximumCartAmount");
            }
            if(promotion.excludeProduct != false || promotion.excludeProductSku != false || promotion.excludeDiscountedProduct != false) {
                conditionArray.push("excludeProduct");
            }
            if(promotion.isNewCustomer != false) {
                conditionArray.push("isNewCustomer");
            }
            if(promotion.isLoggedIn != false) {
                conditionArray.push("isLoggedIn");
            }
            if(promotion.code != false) {
                conditionArray.push("code");
            }

            /* create an array of an options which is enabled in theme settings : end */

            /* check conditions and create an array of an options fulfilled in cart : start */

            if(promotion.excludeProduct) {
                if(promotion.excludeProduct.includes(",")) {
                    promotion.excludeProduct = promotion.excludeProduct.split(", ");
                }
            }
            if(promotion.excludeProductSku) {
                if(promotion.excludeProductSku.includes(",")) {
                    promotion.excludeProductSku = promotion.excludeProductSku.split(", ");
                }
            }
            if (promotion.excludeDiscountedProduct) {
                if (typeof promotion.excludeDiscountedProduct === "string") {
                    promotion.excludeDiscountedProduct = promotion.excludeDiscountedProduct.toLowerCase().split(", ");
                }
            }
            if(promotion.productList1) {
                if(promotion.productList1.includes(",")) {
                    promotion.productList1 = promotion.productList1.split(", ");
                }
            }
            if(promotion.productList2) {
                if(promotion.productList2.includes(",")) {
                    promotion.productList2 = promotion.productList2.split(", ");
                }
            }

            if(promotion.conditionType != false) {
                conditionArray.push(promotion.conditionType);
            }
            if(appliedCode &&
                promotion.code != false &&
                promotion.code.split(", ").includes(appliedCode) &&
                !promotion.conditionArray.includes("code")) {
                promotion.conditionArray.push("code");
            }
            if(promotion.minimumCartAmount && window.cartItemsData.cartTotal >= parseInt(promotion.minimumCartAmount) && !promotion.conditionArray.includes("minimumCartAmount")) {
                promotion.conditionArray.push("minimumCartAmount");
            }
            if(promotion.maximumCartAmount && window.cartItemsData.cartTotal <= parseInt(promotion.maximumCartAmount) && !promotion.conditionArray.includes("maximumCartAmount")) {
                promotion.conditionArray.push("maximumCartAmount");
            }
            if(promotion.conditionType != "any_purchase") {
                if(!promotion.productCount) {
                    promotion.productCount = 1;
                }
                if(promotion.conditionType == "sku") {
                    if(compareArrays(promotion, window.cartItemsData.productSku, promotion.productCount, "sku", i) && !promotion.conditionArray.includes("sku")) {
                        promotion.conditionArray.push("sku");
                    }
                }
                if(promotion.conditionType == "type") {
                    if(compareArrays(promotion, window.cartItemsData.productType, promotion.productCount, "type", i) && !promotion.conditionArray.includes("type")) {
                        promotion.conditionArray.push("type");
                    }
                }
                if(promotion.conditionType == "product_id") {
                    if(compareArrays(promotion, window.cartItemsData.productID, promotion.productCount, "product_id", i) && !promotion.conditionArray.includes("product_id")) {
                        promotion.conditionArray.push("product_id");
                    }
                }
                if(promotion.conditionType == "vendor") {
                    if(compareArrays(promotion, window.cartItemsData.productVendor, promotion.productCount, "vendor", i) && !promotion.conditionArray.includes("vendor")) {
                        promotion.conditionArray.push("vendor");
                    }
                }
            } else {
                if(!promotion.excludeProduct && !promotion.excludeProductSku && !promotion.excludeDiscountedProduct) {
                  window.promotionSettings.gwp[i].includedTotalPrice = window.cartItemsData.cartTotal;
                }
                if(!promotion.conditionArray.includes("any_purchase")) {
                    promotion.conditionArray.push("any_purchase");
                }
            }
            if(promotion.excludeProduct || promotion.excludeProductSku || promotion.excludeDiscountedProduct) {
              var remaining_price = compareArrays(promotion, window.cartItemsData.productType, "", "excludeProduct", i);
              if(remaining_price && !promotion.conditionArray.includes("excludeProduct")) {
                  promotion.conditionArray.push("excludeProduct");
              }
            }
            if(promotion.isNewCustomer && window.theme.isLoggedIn && window.theme.customerSpent == 0 && !promotion.conditionArray.includes("isNewCustomer")) {
                promotion.conditionArray.push("isNewCustomer");
            }
            if(promotion.isLoggedIn && window.theme.isLoggedIn && !promotion.conditionArray.includes("isLoggedIn")) {
                promotion.conditionArray.push("isLoggedIn");
            }

            /* check conditions and create an array of an options fulfilled in cart : end */

            /* Compare both arrays (all options in cart and fulfilled option) */
            if(conditionArray.length == promotion.conditionArray.length) {
                promotion.isCriteriaMeet = true;
            }

            /* create an arrays for add and remove gifts: start */
            if(promotion.isCriteriaMeet && promotion.match_tag  && (promotion.match_tags.length == 0 || (promotion.code && promotion.match_tags.includes(appliedCode)) || !promotion.code)) {
                if(promotion.code && promotion.code.split(", ").includes(appliedCode) && appliedCode != "") {
                    invalidPromotionCode("none");
                    localStorage.setItem("promocode", appliedCode);
                    if(promocode && discountCodeInput) {
                        promocode.setAttribute('readonly', 'readonly');
                        discountCodeInput.classList.add('code-applied');
                        var closeButton = document.querySelector('.discount-code-input-close');
                        if (closeButton) closeButton.hidden = false;
                    }
                }
                if(!promotion.isRandomGift) {
                  for (let i = 0; i < promotion.gifts.length; i++) {
                    let gift = promotion.gifts[i];
                    if(gift && gift.available && promotion.excludeByGwpSku){
                      promotion.excludeByGwpSku.split(",").forEach(item => {
                        excluded_skus.push({"sku": item, "id": gift.id})
                      })
                    }
                    if(gift && gift.available && promotion.excludeByProductSku){
                      promotion.excludeByProductSku.split(",").forEach(item => {
                        excluded_product_skus.push({"sku": item, "id": gift.id})
                      })
                    }
                    if(gift && gift.available && !giftVariantAlreadyInCart(gift.id, response)) {
                      if(gift.item_sku){
                        giftToAdd.push({id: gift.id, quantity: 1, sku: gift.sku, properties: {'Item SKU': gift.item_sku}});
                      }else{
                        giftToAdd.push({id: gift.id, quantity: 1, sku: gift.sku});
                      }
                    }
                  }
                } else {

                    /* select one gift product from 3 to apply randomly */

                    var availableGifts = [];
                    
                    for (let i = 0; i < promotion.gifts.length; i++) {
                        let gift = promotion.gifts[i];
                        if(gift && gift.available) {
                            availableGifts.push(gift);
                        }
                    }

                    // collect all randomly applied gift products
                    alreadyAppliedGift = availableGifts.filter(value => randomGifts.includes(value.id));

                    if(availableGifts.length > 0 && alreadyAppliedGift.length == 0) { // check gift product is already applied to the cart or not
                        var random_number = availableGifts.length > 1 ? Math.floor(Math.random() * availableGifts.length) : 0;
                        for (let index = 0; index < availableGifts.length; index++) {
                            let gift = availableGifts[index];
                            if(random_number == index) {
                                if(gift && gift.available && promotion.excludeByGwpSku){
                                  promotion.excludeByGwpSku.split(",").forEach(item => {
                                    excluded_skus.push({"sku": item, "id": gift.id})
                                  })
                                }
                                if(gift && gift.available && promotion.excludeByProductSku){
                                  promotion.excludeByProductSku.split(",").forEach(item => {
                                    excluded_product_skus.push({"sku": item, "id": gift.id})
                                  })
                                }
                                if(!giftVariantAlreadyInCart(gift.id, response)) { // if gift item is not added to cart
                                    if(gift.item_sku){
                                      giftToAdd.push({id: gift.id, quantity: 1, sku: gift.sku, properties: {'Item SKU': gift.item_sku}});
                                    }else{
                                      giftToAdd.push({id: gift.id, quantity: 1, sku: gift.sku});
                                    }
                                    randomGifts.push(gift.id);
                                    localStorage.setItem("randomGifts", JSON.stringify(randomGifts));
                                }
                            } else {
                                if(gift != false && giftVariantAlreadyInCart(gift.id, response)) { // if gift item is already added to cart
                                    giftToRemove[gift.id] = 0;
                                }
                            }
                        }
                    }
                }
            } else {
              if(promotion.code && promotion.code.split(", ").includes(appliedCode) && appliedCode != "") { // promotion code is valid but not fulfill requirement
                    invalidPromotionCode("block");
                }
                for (let i = 0; i < promotion.gifts.length; i++) {
                    let gift = promotion.gifts[i];
                    // remove rendomly added gift
                    if(randomGifts.includes(gift.id)) {
                        var index = randomGifts.indexOf(gift.id)
                        randomGifts.splice(index, 1);
                        localStorage.setItem("randomGifts", JSON.stringify(randomGifts));
                    }
                    if(gift != false && giftVariantAlreadyInCart(gift.id, response)) {
                        giftToRemove[gift.id] = 0;

                        // remove promotion code and hide error
                        if(promotion.code) {
                            if(promocode && discountCodeInput) {
                                localStorage.removeItem("promocode");
                                promocode.removeAttribute('readonly');
                                discountCodeInput.classList.remove('code-applied');
                                window.clearCodeStack();
                            }
                            invalidPromotionCode("none");
                        }
                    }
                }
            }

          

            /* create an arrays for add and remove gifts: end */
            conditionArray = [];
            promotion.isCriteriaMeet = false;
            promotion.conditionArray = [];
        
        }

        if(excluded_skus.length > 0){
          window.cartItemsData.gifts.forEach(gift => {
            excluded_skus.forEach(excluded_sku => {
              if(excluded_sku.sku == gift.sku){
                giftToRemove[excluded_sku.id] = 0
              }
            })
          })
          giftToAdd.forEach(gift => {
            excluded_skus.forEach(excluded_sku => {
              if(excluded_sku.sku == gift.sku){
                giftToRemove[excluded_sku.id] = 0
              }
            })
          })
        }

        if(excluded_product_skus.length > 0){
          window.cartItemsData.productData.forEach(gift => {
            excluded_product_skus.forEach(excluded_sku => {
              if(excluded_sku.sku == gift.sku){
                giftToRemove[excluded_sku.id] = 0
              }
            })
          })
        }

        /* add/remove gifts from the cart */
        giftToAdd = Array.from(new Map(giftToAdd.map((gift) => [Number(gift.id), gift])).values());
        giftToAdd = giftToAdd.filter((gift) => !giftVariantAlreadyInCart(gift.id, response));
        var addProduct = await _addGiftProduct(giftToAdd, response), removeProduct = await _removeGiftProduct(giftToRemove);
      
        //document.dispatchEvent(new CustomEvent('cart:rerender'));

        if(removeProduct || addProduct) {
          if(addProduct) {
            addProduct.items.forEach((item) => {
              window.cartItemsData.giftsInCart.push(item.id);
            });
          }
          return true;
        } else {
          return false;
        }
      } else {

        /* If cart has not include any main product all gift removed from cart */

        clearCart = await _clearCart();
        if(clearCart.items.length == 0) {
          localStorage.removeItem("randomGifts");
          window.clearCodeStack();
          //document.dispatchEvent(new CustomEvent('cart:rerender'));
          return true;
        }
      }
  })
  .then(() => {
    return window.refreshCart();
  })
  .finally(()=> {
    return true;
  });
}

window.promotionValidate = function () {
  if (!window.promotionSettings || !window.promotionSettings.gwp || !window.promotionSettings.gwp.length) {
    return Promise.resolve(true);
  }

  promotionValidateQueue = promotionValidateQueue.catch(() => {}).then(() => runPromotionValidate());
  return promotionValidateQueue;
};

/* add promotion code on page load */
if (window.promotionSettings?.gwp?.length) {
  window.restoreGwpPromoCodeFromStorage();
  window.promotionValidate();
} else if(window.enablePromotionsUsingCode || window.autoPromotionsEnable) {
  window.restoreGwpPromoCodeFromStorage();
  window.promotionValidate();
}

let arrayToEnWords = function (array) {
  //map object key title only
  array = array.map(function (item) {
    return `<b>${item.title}</b>`;
  });
  let lastWord = array.pop();
  if (array.length > 0) {
    return array.join(", ") +`${KROWN.settings.locales.cart_promotion_and}`+ lastWord;
  } else {
    return `<b>${lastWord}</b>`;
  }
}